import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { banners } from "@/mocks/banners";
import { getSoftwareById, platformLabel } from "@/utils/software";

export default function HeroCarousel() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((v) => (v + 1) % banners.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const go = (dir: number) => {
    setCurrent((v) => (v + dir + banners.length) % banners.length);
  };

  const banner = banners[current];
  const software = getSoftwareById(banner.softwareId);

  return (
    <section className="relative w-full h-[520px] md:h-[600px] overflow-hidden bg-foreground-950">
      {banners.map((b, i) => (
        <div
          key={b.id}
          className={`absolute inset-0 transition-opacity duration-700 ${i === current ? "opacity-100" : "opacity-0"}`}
        >
          <img src={b.image} alt={b.title} title={`${b.title} - 手机软件推荐`} className="w-full h-full object-cover object-top" />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/60 to-foreground-950/30"></div>
        </div>
      ))}

      <div className="relative z-10 w-full max-w-[1240px] mx-auto h-full px-4 md:px-6 flex flex-col justify-center pt-16">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-1.5 text-xs text-background-50 bg-primary-500 rounded-full px-3 py-1 mb-5">
            <span className="flex items-center justify-center w-4 h-4"><i className="ri-flashlight-line" aria-hidden="true"></i></span>
            {banner.tag}
          </span>
          <h1 className="font-heading text-2xl md:text-5xl font-extrabold text-background-50 leading-tight">
            手机中文软件合集与最新版本下载
          </h1>
          <p className="mt-4 text-sm md:text-base text-background-100/90 leading-relaxed">
            最近最新手机中文大全10 汇集社交、工具、游戏、生活等热门中文应用，及时同步最新版本与更新动态，帮你快速找到并了解所需软件。
          </p>

          <div className="mt-5 flex items-center gap-3 text-background-100/80 text-xs md:text-sm">
            <span className="font-heading font-semibold text-background-50">{banner.title}</span>
          </div>
          <p className="mt-2 text-xs md:text-sm text-background-100/70 max-w-xl leading-relaxed line-clamp-2">{banner.subtitle}</p>

          <div className="mt-7 flex flex-wrap items-center gap-3">
            <Link
              to={software ? `/detail/${software.id}` : "/"}
              className="inline-flex items-center gap-2 h-11 px-6 text-sm rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <span className="flex items-center justify-center w-4 h-4"><i className="ri-download-cloud-line" aria-hidden="true"></i></span>
              查看推荐软件
            </Link>
            <Link
              to="/category/social"
              className="inline-flex items-center gap-2 h-11 px-6 text-sm rounded-md bg-background-50/10 text-background-50 border border-background-50/30 hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap backdrop-blur"
            >
              <span className="flex items-center justify-center w-4 h-4"><i className="ri-apps-2-line" aria-hidden="true"></i></span>
              浏览全部分类
            </Link>
          </div>

          {software && (
            <div className="mt-6 flex items-center gap-2 text-xs text-background-100/70">
              <span className="flex items-center justify-center w-4 h-4"><i className="ri-refresh-line" aria-hidden="true"></i></span>
              更新于 {software.updatedAt} · 支持 {software.platforms.map(platformLabel).join(" / ")} · 版本 v{software.version}
            </div>
          )}
        </div>
      </div>

      <div className="absolute z-20 bottom-6 left-4 md:left-6 flex items-center gap-2">
        {banners.map((b, i) => (
          <button
            key={b.id}
            type="button"
            aria-label={`切换到第 ${i + 1} 张推荐`}
            onClick={() => setCurrent(i)}
            className={`h-1.5 rounded-full transition-all cursor-pointer ${i === current ? "w-8 bg-background-50" : "w-4 bg-background-50/40"}`}
          ></button>
        ))}
      </div>

      <div className="absolute z-20 bottom-6 right-3 md:right-6 flex items-center gap-2">
        <button
          type="button"
          aria-label="上一张"
          onClick={() => go(-1)}
          className="flex items-center justify-center w-8 h-8 md:w-10 md:h-10 rounded-full bg-background-50/15 text-background-50 border border-background-50/30 hover:bg-background-50/30 transition-colors cursor-pointer backdrop-blur"
        >
          <i className="ri-arrow-left-s-line text-xl" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          aria-label="下一张"
          onClick={() => go(1)}
          className="flex items-center justify-center w-8 h-8 md:w-10 md:h-10 rounded-full bg-background-50/15 text-background-50 border border-background-50/30 hover:bg-background-50/30 transition-colors cursor-pointer backdrop-blur"
        >
          <i className="ri-arrow-right-s-line text-xl" aria-hidden="true"></i>
        </button>
      </div>
    </section>
  );
}